
import dayjs from 'dayjs'
import { unescape } from '@/utils'

export default {
  name: 'ThumbOverlay',
  components: {
    Overlay: null
  },
  props: {
    size: { // sm, md
      type: String,
      default: 'lg'
    },
    type: { // soldOut, selEnd, adults, release
      type: String,
      default: 'soldOut'
    },
    releaseDt: { // 출시 예정 날짜
      type: String,
      default: ''
    },
    soldPlanDt: { // 판매 예정 날짜
      type: String,
      default: ''
    },
    openRunDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      cssStyle: {
        lg: {
          fontSize: '20px',
          lineHeight: '22px'
        },
        md: {
          fontSize: '16px',
          lineHeight: '18px'
        },
        sm: {
          fontSize: '14px',
          lineHeight: '19px'
        }
      },
      text: '재입고 예정'
    }
  },
  computed: {
    ntcnDate () {
      const opTime = dayjs(this.openRunDate).format('YYYY-MM-DD HH:mm:ss')
      let opRunTime = ''
      let amPm = ''

      if (opTime !== '') {
        const week = ['일', '월', '화', '수', '목', '금', '토']
        const month = new Date(opTime).getMonth() + 1
        const date = new Date(opTime).getDate()
        let time = new Date(opTime).getHours()
        const dayOfWeek = week[new Date(opTime).getDay()]
        if (time < 12) {
          amPm = '오전'
        } else {
          amPm = '오후'
          if (time !== 12) {
            time -= 12
          }
        }

        opRunTime = `${month}/${date}(${dayOfWeek}) ${amPm} ${time}시`
      }
      return opRunTime
    }
  },
  watch: {
    type (value) {
      this.checkOverlayType(value)
    }
  },
  created () {
    this.Overlay = this.$styled('div', { size: String, type: String, cssStyle: Object })`
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      ${(props) => {
        if (props.type === 'tbSold' && props.size !== 'sm') {
          return `
            padding: 24px 22px;
            background: transparent linear-gradient(180deg, #28323C 0%, #28323C00 40%, #28323C00 100%) 0% 0% no-repeat padding-box;
          `
        } else {
          return `
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: rgba(0, 0, 0, .3);
          `
        }
      }}
      font-size: ${props => this.cssStyle[props.size].fontSize};
      line-height: ${props => this.cssStyle[props.size].lineHeight};
      font-weight: 700;
      color: #ffffff;
      z-index: 100;
      span {
        text-align: center;
        ${(props) => {
          if (props.type === 'adults') {
            return `
              width: 80px;
              height: 80px;
              margin: 0 auto;
              line-height: 76px;
              font-size: 28px;
              color: #111111;
              background-color: #ffffff;
              border: 4px solid #D70011;
              border-radius: 50%;
              font-family: 'Daiso';
              z-index: 3;
            `
          }
        }}
      }
      .ico-open-run {
        background-position: center left;
      }
      .open-run {
        margin-top: 6px;
        text-align: left;
      }
    `
    this.checkOverlayType(this.type)
  },
  methods: {
    checkOverlayType (type) {
      const overlayTexts = {
        soldOut: this.size === 'lg' ? '재입고예정' : '재입고<br>예정',
        selEnd: '판매<br>종료',
        adults: '19<span class="blind">세 성인인증</span>',
        release: `출시예정<br>${this.releaseDt}`,
        soldPlan: `판매예정<br>${this.soldPlanDt}`,
        deliveryStop: '정기구매<br>중지',
        optChange: '옵션<br>변경',
        tbSold: this.size !== 'sm' ? `<div class="open-run"><span class="blind">판매시작</span>${this.ntcnDate}</div>` : '판매<br>시작'
      }
      this.text = overlayTexts[type] || '재입고예정'
    },
    unescape (str) {
      return unescape(str)
    },
  }
}
